module.exports = __webpack_public_path__ + "img/specials-multislider-6040--ford.cfca7997.jpeg";